import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { APPSTORE_LINK, PLAYSTORE_LINK } from '../utils/ConstLinks';
import { DownloadAppLinks } from '../components/DownloadAppLinks';

const DownloadWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  background: #000;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 60px;
`;

const DownloadContainer = styled.div`
  padding: 24px;
  background: #fff;
  max-width: 100%;
  margin: 24px;
  border-radius: 6px;
`;

declare const window: Window & { opera: string; MSStream: object };

enum MobileOS {
  WINDOWS,
  ANDROID,
  IOS,
  UNKNOWN,
}

const getMobileOperatingSystem = (): MobileOS => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return MobileOS.WINDOWS;
  }

  if (/android/i.test(userAgent)) {
    return MobileOS.ANDROID;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return MobileOS.IOS;
  }

  return MobileOS.UNKNOWN;
};

export const DownloadApp = (): JSX.Element => {
  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);
  const mobileOS = getMobileOperatingSystem();

  useEffect(() => {
    switch (mobileOS) {
      case MobileOS.IOS:
        setRedirecting(true);
        window.location.href = APPSTORE_LINK;
        break;
      case MobileOS.ANDROID:
        setRedirecting(true);
        window.location.href = PLAYSTORE_LINK;
        break;
      case MobileOS.UNKNOWN:
      case MobileOS.WINDOWS:
      default: {
        setLoading(false);
      }
    }
  }, [mobileOS]);

  return (
    <>
      <DownloadWrapper>
        <div style={{ padding: '40 0' }}>
          <Link to={'/'}>
            <svg
              className="logo"
              width="206"
              height="32"
              viewBox="0 0 206 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 29.5467C8.53333 29.5467 2.56 23.4667 2.56 16C2.56 8.53338 8.53333 2.45338 16 2.45338C23.1467 2.45338 29.0133 7.78672 29.6533 14.8267H23.4667C23.2084 13.0365 22.309 11.401 20.9358 10.2239C19.5625 9.04678 17.8086 8.40818 16 8.42672H11.9467V10.5601H16.2133C17.354 10.5773 18.4562 10.9749 19.3451 11.6899C20.234 12.4049 20.8587 13.3963 21.12 14.5067H6.61333V16.6401H21.12C21.0127 17.9227 20.4263 19.1179 19.4775 19.9876C18.5287 20.8574 17.2871 21.3379 16 21.3334H11.9467V23.4667H16.2133C19.9467 23.4667 23.04 20.8001 23.68 17.0667H29.6533C29.0133 24.1067 23.2533 29.5467 16.1067 29.5467H16ZM16 4.95911e-05C7.46667 4.95911e-05 0 7.14672 0 16C0 24.8534 7.25333 32 16 32C24.7467 32 32 24.8534 32 16C32 7.14672 25.0667 4.95911e-05 16 4.95911e-05ZM50.7733 21.3334H54.4C56.1067 21.3334 57.3867 20.8001 58.4533 19.8401C59.52 18.7734 60.0533 17.4934 60.0533 16C60.0533 14.5067 59.52 13.2267 58.4533 12.16C57.3867 11.0934 56.1067 10.6667 54.4 10.6667H50.7733V21.3334ZM48.4267 23.4667V8.53338H54.4C56.7467 8.53338 58.6667 9.17338 60.16 10.6667C61.6533 12.0534 62.5067 13.8667 62.5067 16C62.5067 18.1334 61.6533 20.0534 60.16 21.3334C58.6667 22.8267 56.7467 23.4667 54.5067 23.4667H48.64H48.4267ZM74.6667 23.4667H77.2267V8.53338H74.6667V23.4667ZM90.6667 23.4667V8.53338H93.12L101.333 19.7334V8.53338H103.68V23.4667H101.12L92.8 12.2667V23.4667H90.6667ZM116.907 23.4667V8.53338H128V10.6667H119.253V14.9334H126.72V16.8534H119.253V21.3334H128.213V23.4667H116.907ZM143.573 19.8401C144.64 20.9067 145.707 21.4401 147.413 21.4401C149.12 21.4401 150.187 21.1201 151.253 20.0534C152.32 18.9867 152.853 17.7067 152.853 16.2134C152.853 14.72 152.32 13.5467 151.253 12.4801C150.187 11.4134 148.907 10.88 147.413 10.88C145.813 10.88 144.533 11.3067 143.467 12.3734C142.4 13.4401 141.973 14.72 141.973 16.2134C141.973 17.7067 142.613 18.9867 143.68 20.0534L143.573 19.8401ZM153.28 21.76C151.68 23.2534 149.867 23.8934 147.627 23.8934C145.493 23.8934 143.36 23.2534 141.973 21.76C140.373 20.2667 139.627 18.56 139.627 16.2134C139.627 14.08 140.373 12.16 141.76 10.6667C143.36 9.17338 145.28 8.53338 147.52 8.53338C149.653 8.53338 151.573 9.17338 153.067 10.6667C154.667 12.16 155.413 13.8667 155.413 16.2134C155.413 18.56 154.667 20.2667 153.067 21.76H153.28ZM178.88 22.0801C177.6 23.3601 176 24.0001 174.08 24.0001C172.373 24.0001 170.88 23.3601 169.493 22.0801C168.213 21.0134 167.573 19.2001 167.573 17.2801V8.53338H169.92V17.0667C169.92 18.3467 170.453 19.4134 171.2 20.2667C172.053 21.0134 173.013 21.3334 174.4 21.3334C175.787 21.3334 176.533 21.0134 177.28 20.2667C178.133 19.4134 178.347 18.3467 178.347 17.0667V8.53338H180.907V17.0667C180.907 18.9867 180.373 20.6934 179.093 21.8667L178.88 22.0801ZM192.427 10.6667V8.53338H205.867V10.6667H200.32V23.4667H197.867V10.6667H192.427Z"
                fill={'#FFF'}
              />
            </svg>
          </Link>
        </div>
        <DownloadContainer>
          {loading && !redirecting && <p>Checking your device type..</p>}
          {redirecting && <p>Redirecting you to the store.</p>}
          {!loading && !redirecting && (
            <>
              <p style={{ marginBottom: 24 }}>
                You can download the app at one of the below stores:
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <DownloadAppLinks />
              </div>
            </>
          )}
        </DownloadContainer>
      </DownloadWrapper>
    </>
  );
};
